import { Card } from "@/components/ui/card";

const Benefits = () => {
  return (
    <section className="py-16">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-center text-foreground mb-12">Benefits at a Glance</h2>
        
        <div className="grid lg:grid-cols-2 gap-8">
          <Card className="p-8 bg-panel border-border">
            <div className="flex items-center gap-4 mb-6">
              <div className="text-3xl">🏠</div>
              <h3 className="text-xl font-semibold text-foreground">For Home Buyers</h3>
            </div>
            
            <Card className="p-6 bg-background border-border">
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-accent rounded-full mt-2"></div>
                  <span className="text-muted-foreground">Buy without the traditional 20% down payment</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-accent rounded-full mt-2"></div>
                  <span className="text-muted-foreground">No additional debt burden</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-accent rounded-full mt-2"></div>
                  <span className="text-muted-foreground">Faster path to homeownership</span>
                </li>
              </ul>
            </Card>
          </Card>
          
          <Card className="p-8 bg-panel border-border">
            <div className="flex items-center gap-4 mb-6">
              <div className="text-3xl">📈</div>
              <h3 className="text-xl font-semibold text-foreground">For Investors</h3>
            </div>
            
            <Card className="p-6 bg-background border-border">
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-investor rounded-full mt-2"></div>
                  <span className="text-muted-foreground">Access to the world's largest illiquid asset class</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-investor rounded-full mt-2"></div>
                  <span className="text-muted-foreground">Diversified exposure to residential appreciation</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-investor rounded-full mt-2"></div>
                  <span className="text-muted-foreground">Participation in a new, tradeable market</span>
                </li>
              </ul>
            </Card>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Benefits;